import React from 'react';
export type YeppyChatMode = 'ascolto' | 'attivita' | 'informazioni';
interface EmptyChatSuggestionsProps {
  mode: YeppyChatMode;
  onModeChange: (mode: YeppyChatMode) => void;
  onShortcutClick?: (prompt: string) => void;
}
export function EmptyChatSuggestions({
  mode,
  onModeChange,
  onShortcutClick
}: EmptyChatSuggestionsProps) {
  return <div className="flex-1 flex flex-col items-center justify-center px-8" data-id="element-128">
      {/* Greeting */}
      <h1 className="font-rubik text-[26px] text-yeppy-text font-medium text-center leading-tight mb-1" data-id="element-129">
        Ciao Fabio 👋
      </h1>

      {/* Subtitle */}
      <h2 className="font-rubik text-[26px] text-yeppy-text font-medium text-center leading-tight mb-4" data-id="element-130">
        Come posso aiutarti oggi?
      </h2>

      {/* Capabilities description */}
      <p className="font-poppins text-[12.5px] text-yeppy-text text-opacity-40 text-center leading-relaxed max-w-[320px]" data-id="element-131">
        Posso ricordare le cose importanti sui bimbi e salvarle nella loro
        scheda, rispondere alle tue domande, o aiutarti a organizzare le
        attività.
      </p>
    </div>;
}